import React from "react";

import DataTable from "react-data-table-component";
import { parseISO, format } from "date-fns";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { JdsButton } from "../../../../components/jds/JdsButton";
import { JdsTag } from "../../../../components/jds/JdsTag";
import { jdsTableStyles } from "../../../../components/jds/tableStyles";
import "../../../../components/jds/jds.css";
import "../../consultas.css";
import { CheckIcon, DocumentIcon, TrashIcon } from "../icons";

const DOCUMENT_TYPE_LABELS = {
  CPF: "CPF",
  CNPJ: "CNPJ",
  PLATE: "Placa",
  PHONE: "Telefone"
};

export function BlackList({
  blackListData,
  handleOpenAttachment,
  handleActivateDocument,
  handleDeleteDocument,
  isOperating
}) {
  const formatDocument = (type, value) => {
    if (!value) return "";

    const onlyDigits = value.replace(/\D/g, "");

    if (type === "CPF") {
      if (onlyDigits.length !== 11) return value;
      return onlyDigits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }

    if (type === "CNPJ") {
      if (onlyDigits.length !== 14) return value;
      return onlyDigits.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    }

    if (type === "PLATE") {
      return value.toUpperCase();
    }

    if (type === "PHONE") {
      if (onlyDigits.length === 11) {
        return onlyDigits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
      }
      if (onlyDigits.length === 10) {
        return onlyDigits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
      }
      return value;
    }
    return value;
  };
  const columns = [
    {
      name: "Documento",
      cell: query => formatDocument(query.documentType, query.document),
      width: "180px"
    },
    {
      name: "Tipo de documento",
      cell: query =>
        DOCUMENT_TYPE_LABELS[query.documentType] ?? query.documentType,
      width: "160px"
    },
    {
      name: "Consultas bloqueadas",
      cell: query => query.queryType.join(", "),
      wrap: true,
      width: "220px"
    },
    {
      name: "Observação",
      cell: query => query.observation ?? "N/A",
      wrap: true,
      width: "220px"
    },
    {
      name: "Anexo",
      cell: query =>
        query.attachment_url ? (
          <JdsButton
            variant="ghost"
            color="neutral"
            size="sm"
            iconOnly
            aria-label="Abrir anexo"
            title="Abrir anexo"
            onClick={() => handleOpenAttachment(query.attachment_url)}
            disabled={isOperating}
          >
            <DocumentIcon />
          </JdsButton>
        ) : (
          "N/A"
        ),
      width: "100px"
    },
    {
      name: "Ativo",
      cell: query => (
        <JdsTag
          label={query.active ? "Ativo" : "Inativo"}
          color={query.active ? "success" : "neutral"}
        />
      ),
      width: "120px"
    },
    {
      name: "Criado por",
      cell: query => query.user,
      wrap: true,
      width: "200px"
    },
    {
      name: "Criado em",
      cell: query => format(parseISO(query.created_at), "dd/MM/yyyy HH:mm"),
      width: "160px"
    },
    {
      name: "Ações",
      cell: query => (
        <div className="consultas-row-actions">
          <JdsButton
            variant="ghost"
            color="error"
            size="sm"
            iconOnly
            aria-label="Excluir documento"
            title="Excluir documento"
            onClick={() => handleDeleteDocument(query.id)}
            disabled={isOperating}
          >
            <TrashIcon />
          </JdsButton>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Ativar/Desativar documento</Tooltip>}
          >
            <JdsButton
              variant="ghost"
              color="neutral"
              size="sm"
              iconOnly
              aria-label="Ativar ou desativar documento"
              onClick={() => handleActivateDocument(query.id, query.active)}
              disabled={isOperating}
            >
              <CheckIcon />
            </JdsButton>
          </OverlayTrigger>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: "120px"
    }
  ];

  return (
    <div className="jds-card jds-card--flush">
      <div className="consultas-card__header">
        <h2 className="jds-title-md">Blacklist de documentos</h2>
      </div>
      <div style={{ overflowX: "auto", width: "100%" }}>
        <DataTable
          columns={columns}
          data={blackListData || []}
          customStyles={jdsTableStyles}
          noDataComponent={
            <div className="consultas-empty">Nenhum documento na blacklist</div>
          }
          responsive={false}
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );
}
